module.exports = __webpack_public_path__ + "static/img/icon_jjc.fcb79539.png";